import { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';

const I = {
  dashboard:  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  cameras:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
  clients:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  reports:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  users:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
  settings:   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  logout:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  alert:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  map:        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>,
  compare:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  holiday:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  goals:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  log:        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>,
  lock:       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  menu:       <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  close:      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
};

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { branding } = useBranding();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  function handleLogout() { logout(); navigate('/login'); }
  const nav = ({ isActive }) => `nav-item ${isActive ? 'active' : ''}`;
  const closeMenu = () => setMobileOpen(false);

  const sidebarContent = (
    <>
      <div className="sidebar-logo">
        {branding.logoData
          ? <img src={branding.logoData} alt="logo" style={{ width:36, height:36, borderRadius:8, objectFit:'cover' }} />
          : <div className="sidebar-logo-icon">📷</div>}
        <div>
          <div className="sidebar-logo-text">{branding.portalName}</div>
          <div className="sidebar-logo-sub">{branding.portalSub}</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {user?.role === 'admin' ? (<>
          <div className="nav-section">Valdymas</div>
          <NavLink to="/admin"          end className={nav} onClick={closeMenu}>{I.dashboard} Apžvalga</NavLink>
          <NavLink to="/admin/clients"      className={nav} onClick={closeMenu}>{I.clients}  Klientai</NavLink>
          <NavLink to="/admin/cameras"      className={nav} onClick={closeMenu}>{I.cameras}  Kameros</NavLink>
          <NavLink to="/admin/map"          className={nav} onClick={closeMenu}>{I.map}      Žemėlapis</NavLink>
          <NavLink to="/admin/reports"      className={nav} onClick={closeMenu}>{I.reports}  Ataskaitos</NavLink>
          <NavLink to="/admin/comparison"   className={nav} onClick={closeMenu}>{I.compare}  Palyginimas</NavLink>
          <div className="nav-section">Sistema</div>
          <NavLink to="/admin/logs"         className={nav} onClick={closeMenu}>{I.log}      Veiklos žurnalas</NavLink>
          <NavLink to="/admin/settings"     className={nav} onClick={closeMenu}>{I.settings} Nustatymai</NavLink>
        </>) : (<>
          <div className="nav-section">Duomenys</div>
          <NavLink to="/dashboard"             end className={nav} onClick={closeMenu}>{I.dashboard} Apžvalga</NavLink>
          <NavLink to="/dashboard/reports"         className={nav} onClick={closeMenu}>{I.reports}  Ataskaitos</NavLink>
          <NavLink to="/dashboard/comparison"      className={nav} onClick={closeMenu}>{I.compare}  Palyginimas</NavLink>
          <NavLink to="/dashboard/map"             className={nav} onClick={closeMenu}>{I.map}      Žemėlapis</NavLink>
          <NavLink to="/dashboard/goals"           className={nav} onClick={closeMenu}>{I.goals}    Tikslai</NavLink>
          <div className="nav-section">Įrankiai</div>
          <NavLink to="/dashboard/alerts"          className={nav} onClick={closeMenu}>{I.alert}    Įspėjimai</NavLink>
          <NavLink to="/dashboard/holidays"        className={nav} onClick={closeMenu}>{I.holiday}  Šventės</NavLink>
          <div className="nav-section">Paskyra</div>
          {!user?.isSubuser && (
            <NavLink to="/dashboard/users"         className={nav} onClick={closeMenu}>{I.users}    Vartotojai</NavLink>
          )}
          <NavLink to="/dashboard/2fa"             className={nav} onClick={closeMenu}>{I.lock}     2FA apsauga</NavLink>
          <NavLink to="/dashboard/settings"        className={nav} onClick={closeMenu}>{I.settings} Nustatymai</NavLink>
        </>)}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{user?.name?.[0]?.toUpperCase() || '?'}</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{user?.name}</div>
            <div className="sidebar-user-role">
              {user?.isSubuser ? 'Papildomas vartotojas' : user?.role === 'admin' ? 'Administratorius' : 'Klientas'}
            </div>
          </div>
        </div>
        <button className="nav-item logout-btn" onClick={handleLogout}
          style={{ width:'100%', background:'none', border:'none', cursor:'pointer', marginTop:4 }}>
          {I.logout} Atsijungti
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop sidebar */}
      <div className="sidebar sidebar-desktop">
        {sidebarContent}
      </div>

      {/* Mobile topbar */}
      <div className="mobile-topbar">
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {branding.logoData
            ? <img src={branding.logoData} alt="logo" style={{ width:28, height:28, borderRadius:6, objectFit:'cover' }} />
            : <div style={{ fontSize:20 }}>📷</div>}
          <span style={{ fontWeight:700, fontSize:15 }}>{branding.portalName}</span>
        </div>
        <button onClick={() => setMobileOpen(!mobileOpen)}
          style={{ background:'none', border:'none', color:'var(--text)', cursor:'pointer', padding:4 }}>
          {mobileOpen ? I.close : I.menu}
        </button>
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="mobile-overlay" onClick={closeMenu} />
      )}

      {/* Mobile drawer */}
      <div className={`sidebar mobile-drawer ${mobileOpen ? 'open' : ''}`}>
        {sidebarContent}
      </div>

      <style>{`
        .sidebar-desktop { display: flex; }
        .mobile-topbar { display: none; }
        .mobile-drawer { display: none; }
        .mobile-overlay { display: none; }

        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }

          .mobile-topbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            background: var(--sidebar-bg, #0d1628);
            border-bottom: 1px solid var(--border);
            position: fixed;
            top: 0; left: 0; right: 0;
            z-index: 100;
            height: 56px;
          }

          .mobile-drawer {
            display: flex !important;
            flex-direction: column;
            position: fixed;
            top: 56px; left: 0; bottom: 0;
            width: 260px;
            z-index: 99;
            transform: translateX(-100%);
            transition: transform 0.3s cubic-bezier(0.22,1,0.36,1);
            overflow-y: auto;
          }
          .mobile-drawer.open {
            transform: translateX(0);
          }

          .mobile-overlay {
            display: block;
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            z-index: 98;
            top: 56px;
          }

          .layout-content {
            margin-left: 0 !important;
            padding-top: 56px !important;
          }
        }
      `}</style>
    </>
  );
}
